import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { ServiceTabItem } from '../../model/service-tab-item/service-tab-item';
import { ServiceTabItemComponent } from '../service/service-tab-item-component';

@Component({
  selector: 'systembar-service-tabs',
  templateUrl: './service-tabs-component.html',
  imports: [ServiceTabItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ServiceTabsComponent {
  @Input() public services: ServiceTabItem[];
}
